import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {CSSTransition, TransitionGroup} from 'react-transition-group';

import './Page.css';

const duration = 1200, {scrollTo} = window;

export default class Page extends Component {

    onEnter = node => {
        const {direction} = this.props, {offsetLeft, parentNode: {
                    offsetWidth
                }} = node;
        Object.assign(node.style, {
            left: Math.abs(offsetLeft)
                ? `${offsetLeft}px`
                : direction === 'left'
                    ? '100%'
                    : '-100%',
            maxWidth: `${offsetWidth}px`,
            position: '',
            top: '',
            width: `${offsetWidth}px`
        });
    }
    onExit = node => {
        const {offsetLeft, offsetHeight} = node, {left, right, top} = node
                .parentNode
                .getBoundingClientRect();
        Object.assign(node.style, {
            left: `${left + offsetLeft}px`,
            maxWidth: `${right - left}px`,
            position: 'fixed',
            top: `${top}px`,
            width: `${right - left}px`
        });
        Object.assign(node.parentNode.style, {minHeight: `${offsetHeight}px`});
        scrollTo(0, 0);
    }
    onEntering = node => {
        const {offsetHeight} = node;
        Object.assign(node.style, {left: ''});
        Object.assign(node.parentNode.style, {minHeight: `${offsetHeight}px`});
    }
    onExiting = node => {
        const {direction} = this.props, {offsetWidth} = node, {left} = node.getBoundingClientRect();
        Object.assign(node.style, {
            left: `${direction === 'left'
                ? left - offsetWidth
                : left + offsetWidth}px`
        });
    }
    onEntered = node => {
        Object.assign(node.style, {
            maxWidth: '',
            width: ''
        });
        Object.assign(node.parentNode.style, {minHeight: ''});
    }

    shouldComponentUpdate({name}) {
        return name !== this.props.name;
    }

    render() {
        // console.log('Page render');
        const {children, className, direction, name} = this.props;
        return <TransitionGroup className={classNames(className, "Page", `Page-direction-${direction}`)}>
            <CSSTransition
                classNames="Page-content"
                className="Page-content"
                key={name}
                onEnter={this.onEnter}
                onExit={this.onExit}
                onEntering={this.onEntering}
                onExiting={this.onExiting}
                onEntered={this.onEntered}
                timeout={duration}
                unmountOnExit={true}>
                {children}
            </CSSTransition>
        </TransitionGroup>;
    }
}

Page.propTypes = {
    direction: PropTypes
        .oneOf(['left', 'right'])
        .isRequired,
    name: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Page.js